import React from 'react'
import { Link } from 'react-router-dom';
const Popular = () => {
    return (
        <>


            <div className="col-lg-4">
                <div className="row g-4">
                    <div className="col-12">
                        <div className="p-3 rounded border">

                            <h4 className="mb-4">लोकप्रिय श्रेणियाँ</h4>
                            <div className="row g-2">

                                <div className="col-12">
                                    <Link to="/Editoal" className=" link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3">
                                        सम्पादकीय
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Study" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3">
                                        शिक्षा
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/khel" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3">
                                        खेल जगत
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Job" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3">
                                        जॉब
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Health" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3">
                                        स्वास्थ्य
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Bussiness" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3 mb-4">
                                        कारोबार
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/District" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3 mb-4">
                                        जनपदीय
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Lokshbha" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3 mb-4">
                                        लोकसभा पंचायत
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Vidhanshbha" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3 mb-4">
                                        विधानसभा पंचायत
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Desh" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3 mb-4">
                                        देश
                                    </Link>
                                </div>
                                <div className="col-12">
                                    <Link to="/Videsh" className="link-hover btn btn-light w-100 rounded text-uppercase text-dark py-3 mb-4">
                                        विदेश
                                    </Link>
                                </div>
                            </div>
                            <h4 className="my-4">संपर्क में रहें</h4>
                            <div className="row g-4">
                                <div className="col-12">
                                    <a href="https://www.facebook.com/profile.php?id=100082809802675" target="_blank" className="w-100 rounded btn btn-primary d-flex align-items-center p-3 mb-2">
                                        <i className="fab fa-facebook-f btn btn-light btn-square rounded-circle me-3"></i>
                                        <span className="text-white">Facebook</span>
                                    </a>
                                    <a href="https://x.com/KhabarPanchayat" target="_blank" className="w-100 rounded btn btn-danger d-flex align-items-center p-3 mb-2">
                                        <i className="fab fa-twitter btn btn-light btn-square rounded-circle me-3"></i>
                                        <span className="text-white">Twitter</span>
                                    </a>
                                    <a href="https://www.youtube.com/@PANCHAYAT_KHABAR" target="_blank" className="w-100 rounded btn btn-warning d-flex align-items-center p-3 mb-2">
                                        <i className="fab fa-youtube btn btn-light btn-square rounded-circle me-3"></i>
                                        <span className="text-white">Youtube</span>
                                    </a>
                                    <a href="https://www.instagram.com/panchayat_khabar/?hl=en" target="_blank" className="w-100 rounded btn btn-dark d-flex align-items-center p-3 mb-2">
                                        <i className="fab fa-instagram btn btn-light btn-square rounded-circle me-3"></i>
                                        <span className="text-white">Instagram</span>
                                    </a>


                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Popular
